import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DishMachineOption } from '../../models/accountData';
import { GenericService } from '../../generic.service';
import { LandingService } from '../../landing-page/service/landing.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-device-types',
    imports: [CommonModule],
    templateUrl: './device-types.component.html',
    styleUrls: ['./device-types.component.scss']
})
export class DeviceTypesComponent {
  qrId: any;
  accountDetails: any = null;
  dishmachineOptions: DishMachineOption[] = [];
  hasDevices: boolean = false;
  selectedMachine: DishMachineOption | null = null;
  showContinueMessage: boolean = false;

  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;

  machineTypeMap: {
    [key: number]: { label: string; image: string; type: string };
  };
  subs = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.machineTypeMap = this.landingService.getMachineTypeMap();
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;
    this.landingService.languageName$.next(this.currentLanguage);

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);

    this.qrId = this.route.snapshot.paramMap.get('id');
    this.accountDetails = this.genericService.getLocalStorage();
    this.accountDetails = this.genericService.syncLocationFromQueryParams(
      this.route.snapshot.queryParamMap,
      this.accountDetails,
    );
    this.genericService.setLocalStorage(this.accountDetails);
    this.accountDetails.Devices.forEach((element: any) => {
      const result = Object.values(this.machineTypeMap).find((item) => {
        return item.label
          .toUpperCase()
          .includes(this.landingService.machineName(element.MachineName));
      });

      if (result) {
        element.image = result.image;
      }
    });
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  onMachineSelect(machine: any) {
    const selectedType = machine?.MachineName || machine?.value || '';
    this.selectedMachine = machine?.MachineName ? machine : null;
    this.accountDetails.selectedMachineType = selectedType;
    this.showContinueMessage = selectedType === 'not-sure';
    this.genericService.setLocalStorage(this.accountDetails);
  }

  getModel(): string | null {
    return this.landingService.setSelectedDevice('model');
  }

  getState(): string | null {
    return this.route.snapshot.queryParamMap.get('state');
  }

  getPostalCode(): string | null {
    return this.route.snapshot.queryParamMap.get('postalCode');
  }

  getCountryCode(): string | null {
    return this.route.snapshot.queryParamMap.get('countryCode');
  }

  getAccountKey(): string | null {
    return this.landingService.getAccountKey();
  }

  getAccountName(): string | null {
    return this.landingService.getAccountName();
  }

  onDone() {
    this.accountDetails.languageSelected = this.currentLanguage;
    this.genericService.setLocalStorage(this.accountDetails);

    this.router
      .navigate(['/support', this.accountDetails.AccountNumber], {
        queryParams: {
          model: this.accountDetails.selectedMachineType || '',
          state: this.accountDetails.state,
          postalCode: this.accountDetails.zip,
          accountName: this.accountDetails.accountName,
          accountKey: this.accountDetails.accountKey,
          languageCode: this.landingService.getLanguageCode(
            this.currentLanguage,
          ),
          countryCode: this.accountDetails.countryCode,
        },
      })
      .then(() => {
        window.location.reload();
      });
  }

  onCancel() {
    this.accountDetails.languageSelected = this.currentLanguage;
    this.genericService.setLocalStorage(this.accountDetails);

    this.router
      .navigate(['/support', this.accountDetails.AccountNumber], {
        queryParams: {
          model: this.getModel(),
          state: this.accountDetails.state,
          postalCode: this.accountDetails.zip,
          accountName: this.accountDetails.accountName,
          accountKey: this.accountDetails.accountKey,
          languageCode: this.landingService.getLanguageCode(
            this.currentLanguage,
          ),
          countryCode: this.accountDetails.countryCode,
        },
      })
      .then(() => {
        window.location.reload();
      });
  }
}
